// AboutUs.js
import React from 'react';
import '../../styles/pages/About.css';

function AboutUs() {
  return (
    <div className="about">
      <h1>About Us</h1>
      <p>
        Welcome to Little Lemon Restaurant, where culinary artistry meets warm hospitality. Nestled in the heart of our vibrant city, we've been serving up unforgettable dining experiences since our humble beginnings.
        Our passion for food is at the core of everything we do. We believe in the power of flavors to create lasting memories, and we're dedicated to bringing you the finest in gastronomy. Each dish that leaves our kitchen is a masterpiece, carefully crafted with the freshest ingredients and a dash of creativity.
      </p>
      <p>
        At Little Lemon, we're more than just a restaurant, we're a gathering place for friends and families to celebrate life's moments, both big and small. Our welcoming ambiance and attentive staff are here to ensure your visit is nothing short of exceptional.
        Explore our menu, where you'll find a delightful fusion of traditional and contemporary cuisine. From savory appetizers to decadent desserts, every bite is an exploration of taste and texture. We're proud to offer a diverse selection that caters to all palates.
      </p>
      <p>
        As we grow and evolve, we remain committed to sustainability and community engagement. We source locally whenever possible, supporting our neighboring farmers and artisans. Our dedication to reducing our environmental footprint is an ongoing journey that we're proud to share with you.
        Thank you for choosing Little Lemon Restaurant as your dining destination. We look forward to serving you and creating moments to cherish.
      </p>
      <p>
        Savor the flavors, embrace the ambiance, and make yourself at home. Little Lemon Restaurant is your culinary sanctuary.
      </p>
    </div>
  );
}

export default AboutUs;
